import React, { useEffect, useState } from "react";

import "./PendingApproval.css";
import { Link } from "react-router-dom";
import {
  List,
  Grid,
  Eye,
  Edit,
  UserX,
  UserCheck,
  CheckSquare,
} from "react-feather";
import PendingApprovalViewModal from "./PendingApprovalViewModal";
import ActionConfirmation from "../../../Components/ActionConfirmation/ActionConfirmation";
import NoDataFound from "../../../Components/NoDataFound/NoDataFound";
import { PulseLoader } from "react-spinners";
const PendingApproval = () => {
  const {
    PendingStudents,
    PendingParents,
    PendingTeachers,
    PendingDialog,
    handleOpenPendingDialog,
    handleClosePendingDialog,
    ActionTab,
    setActionTab,
    IsLoading,
    navigate,
  } = PendingApprovalViewModal();

  const [CurrentTab, setCurrentTab] = useState(1); // CurrentTab == 1 ,Teacher  CurrentTab == 2 ,students  CurrentTab == 3 ,parents
  const [EmailFilter, setEmailFilter] = useState("");
  const [NameFilter, setNameFilter] = useState("");
  const [GenderFilter, setGenderFilter] = useState("");
  return (
    <>
      <ActionConfirmation
        title={ActionTab == 1 ? "Reject User" : "Approve User"}
        description={
          ActionTab == 1
            ? "Are you sure you want to reject this user?"
            : "Are you sure you want to Approve this user?"
        }
        openDialog={PendingDialog}
        handleCloseDialog={handleClosePendingDialog}
      />

      <div className="page-wrapper admin-pending-users-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <div className="page-sub-header">
                  <h3 className="page-title">Pending Users</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/user/admin/dashboard">Admin</Link>
                    </li>
                    <li className="breadcrumb-item active">Pending users</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="student-group-form">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Name ..."
                    onChange={(e) => {
                      setNameFilter(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Email ..."
                    onChange={(e) => {
                      setEmailFilter(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Gender ..."
                    onChange={(e) => {
                      setGenderFilter(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-2">
                <div className="search-student-btn">
                  <button type="btn" className="btn btn-primary">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table comman-shadow">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-md-12">
                      <div className="card bg-white">
                        <div className="card-body">
                          <ul className="nav nav-tabs pending-users-nav">
                            <li
                              className="nav-item"
                              onClick={() => {
                                setCurrentTab(1);
                              }}
                            >
                              <a
                                className={`nav-link ${
                                  CurrentTab === 1 ? " active" : ""
                                } `}
                              >
                                Teachers
                              </a>
                            </li>
                            <li
                              className="nav-item"
                              onClick={() => {
                                setCurrentTab(2);
                              }}
                            >
                              <a
                                className={`nav-link ${
                                  CurrentTab === 2 ? " active" : ""
                                } `}
                              >
                                Students
                              </a>
                            </li>
                            <li
                              className="nav-item"
                              onClick={() => {
                                setCurrentTab(3);
                              }}
                            >
                              <a
                                className={`nav-link  ${
                                  CurrentTab === 3 ? " active" : ""
                                } `}
                              >
                                Parents
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Gender</th>

                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {CurrentTab === 1
                            ? PendingTeachers?.length > 0 &&
                              PendingTeachers.filter(
                                (teacher) =>
                                  GenderFilter === "" ||
                                  teacher.Gender.toLowerCase().includes(
                                    GenderFilter.toLowerCase()
                                  )
                              )
                                .filter(
                                  (teacher) =>
                                    NameFilter === "" ||
                                    `${teacher.FirstName} ${teacher.LastName}`
                                      .toLowerCase()
                                      .includes(NameFilter.toLowerCase())
                                )
                                .filter(
                                  (teacher) =>
                                    EmailFilter === "" ||
                                    teacher.Email.toLowerCase().includes(
                                      EmailFilter.toLowerCase()
                                    )
                                )
                                .map((teacher, index) => {
                                  return (
                                    <tr
                                      className="user-table-row"
                                      onClick={() => {
                                        navigate(
                                          `/user/admin/users/profile/${teacher?.id}`
                                        );
                                      }}
                                      key={index}
                                    >
                                      <td>{index + 1}</td>
                                      <td>
                                        <h2 className="table-avatar">
                                          <a className="text-capitalize">
                                            {teacher?.FirstName +
                                              " " +
                                              teacher?.LastName}
                                          </a>
                                        </h2>
                                      </td>
                                      <td>{teacher?.Email}</td>
                                      <td className="text-capitalize">
                                        {teacher?.Gender}
                                      </td>

                                      <td className="text-end">
                                        <div className="actions">
                                          <a
                                            className="btn btn-sm bg-success-light me-2 "
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setActionTab(1);
                                              handleOpenPendingDialog(
                                                teacher.uid
                                              );
                                            }}
                                          >
                                            <UserX size={18} />
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setActionTab(2);
                                              handleOpenPendingDialog(
                                                teacher.uid
                                              );
                                            }}
                                            className="btn btn-sm bg-danger-light"
                                          >
                                            <CheckSquare size={18} />
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                            : CurrentTab === 2
                            ? PendingStudents.length > 0 &&
                              PendingStudents.filter(
                                (student) =>
                                  GenderFilter === "" ||
                                  student.Gender.toLowerCase().includes(
                                    GenderFilter.toLowerCase()
                                  )
                              )
                                .filter(
                                  (student) =>
                                    NameFilter === "" ||
                                    `${student.FirstName} ${student.LastName}`
                                      .toLowerCase()
                                      .includes(NameFilter.toLowerCase())
                                )
                                .filter(
                                  (student) =>
                                    EmailFilter === "" ||
                                    student.Email.toLowerCase().includes(
                                      EmailFilter.toLowerCase()
                                    )
                                )
                                .map((student, index) => {
                                  return (
                                    <tr
                                      className="user-table-row"
                                      onClick={() => {
                                        navigate(
                                          `/user/admin/users/profile/${student?.id}`
                                        );
                                      }}
                                      key={index}
                                    >
                                      <td>{++index}</td>
                                      <td>
                                        <h2 className="table-avatar">
                                          <a className="text-capitalize">
                                            {student?.FirstName +
                                              " " +
                                              student?.LastName}
                                          </a>
                                        </h2>
                                      </td>
                                      <td> {student?.Email}</td>
                                      <td className="text-capitalize">
                                        {" "}
                                        {student?.Gender}
                                      </td>

                                      <td className="text-end">
                                        <div className="actions ">
                                          <a
                                            className="btn btn-sm bg-success-light me-2"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleOpenPendingDialog(
                                                student.uid
                                              );
                                              setActionTab(1);
                                            }}
                                          >
                                            <UserX size={18} />
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleOpenPendingDialog(
                                                student.uid
                                              );
                                              setActionTab(2);
                                            }}
                                            className="btn btn-sm bg-danger-light"
                                          >
                                            <CheckSquare size={18} />
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                            : CurrentTab === 3
                            ? PendingParents.length > 0 &&
                              PendingParents.filter(
                                (parent) =>
                                  GenderFilter === "" ||
                                  parent.Gender.toLowerCase().includes(
                                    GenderFilter.toLowerCase()
                                  )
                              )
                                .filter(
                                  (parent) =>
                                    NameFilter === "" ||
                                    `${parent.FirstName} ${parent.LastName}`
                                      .toLowerCase()
                                      .includes(NameFilter.toLowerCase())
                                )
                                .filter(
                                  (parent) =>
                                    EmailFilter === "" ||
                                    parent.Email.toLowerCase().includes(
                                      EmailFilter.toLowerCase()
                                    )
                                )
                                ?.map((parent, index) => {
                                  return (
                                    <tr
                                      className="user-table-row"
                                      onClick={() => {
                                        navigate(
                                          `/user/admin/users/profile/${parent?.id}`
                                        );
                                      }}
                                      key={index}
                                    >
                                      <td>{index + 1}</td>
                                      <td>
                                        <h2 className="table-avatar">
                                          <a className="text-capitalize">
                                            {parent?.FirstName +
                                              " " +
                                              parent?.LastName}
                                          </a>
                                        </h2>
                                      </td>
                                      <td>{parent?.Email}</td>
                                      <td className="text-capitalize">
                                        {parent?.Gender}
                                      </td>

                                      <td className="text-end">
                                        <div className="actions">
                                          <a
                                            className="btn btn-sm bg-success-light me-2"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setActionTab(1);
                                              handleOpenPendingDialog(
                                                parent.uid
                                              );
                                            }}
                                          >
                                            <UserX size={18} />
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleOpenPendingDialog(
                                                parent.uid
                                              );
                                              setActionTab(2);
                                            }}
                                            className="btn btn-sm bg-danger-light"
                                          >
                                            <CheckSquare size={18} />
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                            : ""}
                        </tbody>
                      </table>
                      {CurrentTab === 1 && PendingTeachers?.length <= 0 && (
                        <NoDataFound />
                      )}
                      {CurrentTab === 2 && PendingStudents?.length <= 0 && (
                        <NoDataFound />
                      )}
                      {CurrentTab === 3 && PendingParents?.length <= 0 && (
                        <NoDataFound />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingApproval;
